import { ConfigContext } from 'contexts/config';
import { replacePlaceholder } from 'helpers/cms';
import { usePoliciesByCountryCode } from 'modules/policies/hooks/usePoliciesByCountryCode';
import { useContext } from 'react';
import { AnjouanSeal } from '../AnjouanSeal';
import { TobiqueSeal } from '../TobiqueSeal';
import { ScCopyright } from './styled';

export const Copyright = () => {
  const currentFullYear = new Date().getFullYear();

  const { footerCopyright } = useContext(ConfigContext);
  const licenseContent = usePoliciesByCountryCode(footerCopyright);

  const license = replacePlaceholder(
    licenseContent,
    'year',
    String(currentFullYear)
  );

  return (
    <ScCopyright>
      <div className="license-link">
        <TobiqueSeal />
        <AnjouanSeal />
      </div>
      <div
        className="copyright"
        dangerouslySetInnerHTML={{ __html: license }}
      />
    </ScCopyright>
  );
};
